var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "form-container" },
        [
          _c(
            "el-form",
            {
              ref: "liveForm",
              staticClass: "liveForm",
              attrs: {
                model: _vm.liveForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "卡片名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "99",
                      size: "small",
                      placeholder: "请输入卡片名称",
                      clearable: "",
                    },
                    model: {
                      value: _vm.liveForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "name", $$v)
                      },
                      expression: "liveForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "卡片标题", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "99",
                      size: "small",
                      placeholder: "请输入卡片标题",
                      clearable: "",
                    },
                    model: {
                      value: _vm.liveForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "title", $$v)
                      },
                      expression: "liveForm.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "卡片描述", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "99",
                      size: "small",
                      placeholder: "请输入卡片描述",
                      clearable: "",
                    },
                    model: {
                      value: _vm.liveForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "description", $$v)
                      },
                      expression: "liveForm.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "图片", prop: "coverImg" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "avatar-uploader",
                      attrs: {
                        "before-upload": _vm.fileCheck,
                        "http-request": _vm.upload,
                        "show-file-list": false,
                      },
                    },
                    [
                      _vm.liveForm.coverImg
                        ? _c("el-image", {
                            staticClass: "avatar",
                            attrs: {
                              src: _vm.liveForm.coverImg,
                              fit: "scale-down",
                            },
                          })
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon",
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "图片宽度尺寸" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.liveForm.imgSelectWidth,
                        callback: function ($$v) {
                          _vm.$set(_vm.liveForm, "imgSelectWidth", $$v)
                        },
                        expression: "liveForm.imgSelectWidth",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "300" } }, [
                        _vm._v("小图：300px (推荐)"),
                      ]),
                      _c("el-radio", { attrs: { label: "700" } }, [
                        _vm._v("大图：700px (推荐)"),
                      ]),
                      _c("el-radio", { attrs: { label: -1 } }, [
                        _vm._v("自定义图片宽度"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "top",
                        width: "200",
                        trigger: "hover",
                        content:
                          "如果输入了自定义图片宽度，以自定义图片宽度为准",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-question",
                        staticStyle: {
                          "margin-left": "40px",
                          color: "#507dc5",
                        },
                        attrs: { slot: "reference" },
                        slot: "reference",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm.liveForm.imgSelectWidth === -1
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入图片宽度(单位px)",
                          clearable: "",
                        },
                        model: {
                          value: _vm.liveForm.imgWidth,
                          callback: function ($$v) {
                            _vm.$set(_vm.liveForm, "imgWidth", $$v)
                          },
                          expression: "liveForm.imgWidth",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "赛程列表", prop: "items" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.selectAppCards },
                    },
                    [_vm._v("选择")]
                  ),
                  _vm.liveForm.items.length
                    ? _c(
                        "avue-crud",
                        {
                          ref: "crud",
                          staticStyle: { width: "100%" },
                          attrs: {
                            option: _vm.option,
                            data: _vm.liveForm.items,
                          },
                          on: { "sortable-change": _vm.sortChange },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "teamA",
                                fn: function ({ row }) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(row.teamA) +
                                          " VS " +
                                          _vm._s(row.teamB)
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "teamAImg",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        row.teamAImg
                                          ? _c("el-image", {
                                              staticStyle: {
                                                width: "100px",
                                                height: "100px",
                                              },
                                              attrs: {
                                                src: row.teamAImg,
                                                fit: "scale-down",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(
                                          "\n              VS\n              "
                                        ),
                                        row.teamBImg
                                          ? _c("el-image", {
                                              staticStyle: {
                                                width: "100px",
                                                height: "100px",
                                              },
                                              attrs: { src: row.teamBImg },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "matchStartTime",
                                fn: function ({ row }) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(row.matchStartTime) +
                                          " - " +
                                          _vm._s(row.matchEndTime)
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "operation",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "text",
                                          size: "small",
                                          disabled: !_vm.canMoveUp(
                                            _vm.liveForm.items,
                                            row
                                          ),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moveUp(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              上移\n            "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "text",
                                          size: "small",
                                          disabled: !_vm.canMoveDown(
                                            _vm.liveForm.items,
                                            row
                                          ),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moveDown(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              下移\n            "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "text",
                                          size: "small",
                                          disabled: !_vm.canMoveTop(
                                            _vm.liveForm.items,
                                            row
                                          ),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moveTop(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              置顶\n            "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "#f56c6c" },
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.remove(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              移除\n            "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1609903550
                          ),
                        },
                        [_c("template", { slot: "mySearch" })],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "9999",
                      "show-word-limit": "",
                      size: "small",
                      type: "textarea",
                      placeholder: "请输入备注",
                      clearable: "",
                    },
                    model: {
                      value: _vm.liveForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.liveForm, "remark", $$v)
                      },
                      expression: "liveForm.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.liveForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.liveForm, "status", $$v)
                        },
                        expression: "liveForm.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("生效")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("失效")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.liveForm.status === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "选择", prop: "effectMode" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.liveForm.effectMode,
                            callback: function ($$v) {
                              _vm.$set(_vm.liveForm, "effectMode", $$v)
                            },
                            expression: "liveForm.effectMode",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("立即生效"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("指定时间生效"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.liveForm.status === 1 && _vm.liveForm.effectMode === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "生效时间", prop: "effectTime" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          size: "small",
                          "picker-options": {
                            disabledDate(time) {
                              return time.getTime() < Date.now() - 8.64e7
                            },
                          },
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "生效开始时间",
                          "end-placeholder": "生效结束时间",
                          clearable: "",
                        },
                        model: {
                          value: _vm.liveForm.effectTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.liveForm, "effectTime", $$v)
                          },
                          expression: "liveForm.effectTime",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "btn-container",
          staticStyle: { "text-align": "right", "margin-top": "20px" },
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.save },
            },
            [_vm._v("保存")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
      _c("RaceCard", { ref: "raceCard", on: { save: _vm.getContentList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }